import { useAuth0 } from "@auth0/auth0-react";
import { type DependencyList, useEffect } from "react";
import type { Database } from "../../../__definitions__/database-definitions";
import { useClaims } from "../../../modules/generic/hooks/use-claims";
import type { SupabaseHandlerArg, SupabaseSchemaName } from "./types";
import { withSupabaseToken } from "./utils";
/**
 * An Effect for loading data from Supabase; may redirect if not authenticated.
 */
export function useSupabase<SchemaName extends SupabaseSchemaName<Database> = "public">(
  callback: (arg0: SupabaseHandlerArg<SchemaName>) => Promise<void>,
  deps: DependencyList,
  schema: SchemaName = "public" as SchemaName,
): void {
  const { isLoading, isAuthenticated, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const claims = useClaims();

  useEffect(() => {
    const abortController = new AbortController();
    void withSupabaseToken<SchemaName>(
      claims,
      isLoading,
      isAuthenticated,
      getAccessTokenSilently,
      loginWithRedirect,
      schema,
      abortController,
    )
      .then((ctx) => (ctx ? callback({ ...ctx, abortController }) : null))
      .catch(console.error);
    return () => {
      abortController?.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claims, isLoading, loginWithRedirect, getAccessTokenSilently, schema, ...deps]);
}
